import { render, staticRenderFns } from "./BisMenuJournalBohemica.vue?vue&type=template&id=8d794e24&scoped=true"
import script from "./BisMenuJournalBohemica.vue?vue&type=script&lang=js"
export * from "./BisMenuJournalBohemica.vue?vue&type=script&lang=js"
import style0 from "./BisMenuJournalBohemica.vue?vue&type=style&index=0&id=8d794e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d794e24",
  null
  
)

export default component.exports